export default function formatName(_reportName: string, lengthToCheck: number) {
  const nameToShow =
    _reportName.length > lengthToCheck
      ? `${_reportName.slice(0, lengthToCheck)}...`
      : _reportName;

  return nameToShow;
}
